import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  UpdateStatus,
} from "../../../../../../../features/admin/website/home/faq/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const faq = useSelector((state) => state?.website?.faq);

  console.log(faq, "whoWeAre");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = faq?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: faq?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(UpdateStatus(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    faq,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
